import dropdown, { formDropdownVariants, FormDropdownVariantsType } from './dropdown';
import input from './input';

export const formVariants = {
  dropdown: formDropdownVariants,
};

const form = {
  dropdown,
  input,
};

export type FormVariantsType = 'dropdown' | 'input';

export interface FormType {
  /** The Nav subcomponent types. */
  Components: FormVariantsType;
  /** The Dropdown component types. */
  Dropdown: FormDropdownVariantsType;
}

export default form;
